export const routes = {
  MAIN: '/',
  MEETING_GROUP: '/meeting-group',
  SERVERS: '/workspace',
  SESSIONS: '/conversation',
  DISCORD_VOICES: '/discord-voices',
};
